import { useState, useEffect } from "react";
import useMeteringPoints from "./useMeteringPoints";

function useRefPeriods() {
  const { getQuarantined, getRefPeriodChanged, getWithoutReferencePeriod } = useMeteringPoints();  
  const [quarantined, setQuarantined] = useState([]);
  const [changed, setChanged] = useState([]); 
  const [withoutRefPeriod, setWithoutRefPeriod] = useState([]); 
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getQuarantined(), 
      getRefPeriodChanged(),
      getWithoutReferencePeriod()
    ]).then(result => {
      setQuarantined(result[0])
      setChanged(result[1])
      setWithoutRefPeriod(result[2])
      setLoading(false);
    })
  }, [])

  return { loading, quarantined, changed, withoutRefPeriod};
}

export default useRefPeriods;